import { connect } from 'react-redux';
import CloudAcquisitionTopicBuildComponent from
  '../Components/CloudAcquisitionTopicBuildComponent';
import { _parseHash, _handleChange } from './../helpers/cloudhelpers.js';
import { getCloudAcquisitions } from '../reducers';

let filteredAcquisitions = [];

export const mapStateToProps = (state) => {
  let acquisitions = getCloudAcquisitions(state);
  const buildNumber = _parseHash(location.hash);
  filteredAcquisitions = acquisitions.filter(
    function (acquisition) {
      return acquisition.topicJobNumber.toString() === buildNumber;
    }
  );
  acquisitions = filteredAcquisitions;
  return {
    onChange: () => _handleChange,
    buildNumber: buildNumber,
    acquisitions: acquisitions
  };
};


export default connect(mapStateToProps)(CloudAcquisitionTopicBuildComponent);



// WEBPACK FOOTER //
// src/Containers/CloudAcquisitionTopicBuildContainer.jsx